import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    choosePaymentMethodTitle: {
        id: '_.modal.choose_payment_method_title',
        defaultMessage:
            'Would you like to link a debit card or add bank details?'
    },
    debitCard: {
        id: '_.modal.choose_payment_method_debit_card',
        defaultMessage: 'Debit card'
    },
    bankAccount: {
        id: '_.modal.choose_payment_method_bank_account',
        defaultMessage: 'Bank account'
    },
    usedForRepayments: {
        id: '_.modal.choose_payment_method_used_for_repayments',
        defaultMessage: 'Used for repayments'
    },
    usedForFundings: {
        id: '_.modal.choose_payment_method_used_for_fundings',
        defaultMessage: 'Used for fundings'
    }
});
